import { render, staticRenderFns } from "./textTwoColumns.vue?vue&type=template&id=5222ac4b&"
import script from "./textTwoColumns.vue?vue&type=script&lang=js&"
export * from "./textTwoColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports